// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  Alert,
  Tooltip,
  Container,
  Typography,
} from "@mui/material";
import LoginForm from "../components/LoginForm";

// ----------------------------------------------------------------------

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <Container title="Login | Minimal-UI">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                Sign in to Minimal
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                Enter your details below.
              </Typography>
            </Box>

            <Tooltip title="Login">
              <Box
                component="img"
                src={`/images/illustration_login.png`}
                sx={{ width: 32, height: 32 }}
              />
            </Tooltip>
          </Stack>

          <Alert severity="info" sx={{ mb: 3 }}>
            Liên hệ admin để lấy tài khoản
            <strong>&nbsp;tài khoản</strong>
          </Alert>

          <LoginForm />
        </ContentStyle>
      </Container>
    </Container>
  );
}
